import api from "@/api";
import moment from "moment-timezone";

function formatBringgEta(bringgDate) {
  return moment(bringgDate).format("h:mm a");
}

async function setLocalOrder() {
  const orderId = this.localOrderId || this.orderNumber;
  const res = await api({
    params: { filter: orderId },
    url: "/123/orders/store_orders",
  });
  this.localOrder = res.info[0];
}

function getUrlParams() {
  const params = {};
  const url = new URL(window.location.href);

  url.searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
}

function formatBringgStatus(orderStatus, orderHistoryPage = false) {
  switch (orderStatus) {
    case null:
      return { orderStep: 1, status: "Received" };
    case 2:
      return { orderStep: 2, status: "Preparing" };
    case "driver_on_the_way":
      return { orderStep: 3, status: "Delivering" };
    case "task_checked_in":
      return {
        orderStep: 4,
        status: orderHistoryPage ? "Delivery Completed" : "Complete",
      };
    default:
      return { orderStep: 0, status: "Unknown" };
  }
}

function formatOrderStatus(statusCode) {
  switch (statusCode) {
    case 1:
      return { orderStatus: "Submitted" };
    case 5:
      return { orderStatus: "Delivery Completed" };
    case 7:
      return { orderStatus: "Cancelled by Store" };
    case 9:
      return { orderStatus: "Authorization Failure" };
    case 10:
      return { orderStatus: "Payment Failure" };
    case 11:
      return { orderStatus: "Refunded" };
    case 17:
      return { orderStatus: "Ready For Picking" };
    case 18:
      return { orderStatus: "Ready For Delivery" };
    case 19:
      return { orderStatus: "Picking" };
    case 20:
      return { orderStatus: "Cancelled by Store" };
    case 30:
      return { orderStatus: "Pulled" };
    default:
      return { orderStatus: "Order status unknown" };
  }
}

export {
  formatBringgEta,
  formatBringgStatus,
  formatOrderStatus,
  getUrlParams,
  setLocalOrder,
};
